import React from 'react';

import { AuthConsumer } from '../../react-check-auth';

import { withFirebase } from '../Firebase';

const needsEmailVerification = userInfo =>{return false;
  // TODO: Business requirements dont state the need for this
  // return userInfo;
}
   /*userInfo &&
  !userInfo.emailVerified &&
  userInfo.providerData
    .map(provider => provider.providerId)
    .includes('password')*/;

const withEmailVerification = Component => {
  class WithEmailVerification extends React.Component {
    constructor(props) {
      super(props);

      this.state = { isSent: false };
    }

    onSendEmailVerification = () => {
      this.props.firebase
        .doSendEmailVerification()
        .then(() => this.setState({ isSent: true }));
    };

    render() {
      return (
        <AuthConsumer>
          {({userInfo}) =>
            needsEmailVerification(userInfo) ? (
              <div>
                {this.state.isSent ? (
                  <p>
                    E-Mail confirmation sent: Check your E-Mails (Spam
                    folder included) for a confirmation E-Mail.
                    Refresh this page once you confirmed your E-Mail.
                  </p>
                ) : (
                  <p>
                    Verify your E-Mail: Check your E-Mails (Spam folder
                    included) for a confirmation E-Mail or send
                    another confirmation E-Mail.
                  </p>
                )}

                <button
                  type="button"
                  onClick={this.onSendEmailVerification}
                  disabled={this.state.isSent}
                >
                  Send confirmation E-Mail
                </button>
              </div>
            ) : (
              <Component {...this.props} />
            )
          }
        </AuthConsumer>
      );
    }
  }

  return withFirebase(WithEmailVerification);
};

export default withEmailVerification;
